import { toast } from 'react-toastify';

import { getUser, getPatchUserMutationOptions } from '@vlabs/api/artemy/client';
import { queryClient } from '@vlabs/api/queryClient';

import { detachUserDepartmentsTranslation as t } from './i18n';
import type { DetachUserDepartmentsProps } from './types';

interface DetachUserDepartmentsParams extends DetachUserDepartmentsProps {
  onDetachUserDepartments?: VoidFunction;
}

export async function detachUserDepartments({
  userId,
  departmentIds,
  onDetachUserDepartments,
}: DetachUserDepartmentsParams): Promise<void> {
  if (!departmentIds.length) return;

  try {
    const user = await getUser(userId);

    await queryClient.mutateAsync(
      getPatchUserMutationOptions(queryClient),
      {
        userId,
        data: {
          department_ids: user.department_ids.filter(
            (departmentId) => !departmentIds.includes(departmentId),
          ),
        },
      },
    );

    onDetachUserDepartments?.();
    toast.success(t('toast_success'));
  } catch {
    toast.error(t('toast_error'));
  }
}
